import React from 'react';

import MainView from './main.view';

const MainController: React.FC = () => {
  return <MainView />;
};

export default MainController;
